export default __webpack_public_path__ + "static/media/setting.ea4b3d11.JPG";